//firebase configration
const firebaseConfig = {
  apiKey: "AIzaSyCZ9rQQvxmxwGZ5hIp9aVYpSXOBqIlaR20",
  authDomain: "health-care-b8ac1.firebaseapp.com",
  projectId: "health-care-b8ac1",
  storageBucket: "health-care-b8ac1.appspot.com",
  messagingSenderId: "31973048992",
  appId: "1:31973048992:web:f8ad48fb2c6d5e3b63ffc5"
};

export default firebaseConfig;